export default __webpack_public_path__ + "static/media/hslDefault.6096609f.svg";